/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'animate.css/animate.css';

import React from 'react';
import isNil from 'lodash/isNil';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
  HelpBlock,
  Breadcrumb,
  Panel,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import SearchSelector from 'loracoms/SearchSelector';
import RichButton from 'loracoms/RichButton';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import enumsActions from 'loraactions/enums';
import gatewayActions from 'loraactions/gateway';
import usageActions from 'loraactions/usage';
import {
  formatMacInput,
  isValidMac,
  normalizeMac,
} from 'lorautils/IdUtils';
import styles from './styles/main.scss';
import { platOptsSelector } from './selectors';

const propTypes = {
  addGateway: React.PropTypes.func.isRequired,
  addResult: React.PropTypes.object.isRequired,
  getPlatforms: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  platOpts: React.PropTypes.array.isRequired,
  pushState: React.PropTypes.func.isRequired,
  getGatewayUsage: React.PropTypes.func.isRequired,
};

class GatewayAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      platOpts: props.platOpts,
      formStatus: 'ready',
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'plat')
          .add('FE_EMPTY', 'name')
          .add('FE_EMPTY', 'mac')
      ),
    };
    this.handleChangePlat = this.handleChangePlat.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeMac = this.handleChangeMac.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.gatewayadd');
  }

  componentWillMount() {
    this.props.getPlatforms();
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const { platOpts, addResult } = nextProps;
    if (platOpts !== this.props.platOpts) {
      this.setState({ platOpts });
    }
    if (addResult !== this.props.addResult) {
      this.setState({ addStatus: addResult.status });
      if (addResult.status === 'failure') {
        const { error: { code } } = addResult;
        let { errors } = this.state;
        errors = errors.add(code, 'submit');
        this.setState({ errors });
        if (code === 'MACADDRUNAVAIL') {
          errors = errors.add(code, 'mac');
          this.setState({ errors });
        }
      } else if (addResult.status === 'success') {
        const { pushState, getGatewayUsage } = nextProps;
        getGatewayUsage();
        setTimeout(() => pushState('/gateway'), 500);
      }
    }
  }

  componentDidUpdate() {
    const { macCurPos } = this.state;
    if (macCurPos) {
      this.macInputRef.setSelectionRange(macCurPos, macCurPos);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  addEmptyError(target) {
    const { errors } = this.state;
    this.setState({
      errors: errors.add('FE_EMPTY', target),
    });
  }

  removeError(target) {
    const { errors } = this.state;
    this.setState({
      errors: errors.remove(target),
    });
  }

  handleChangePlat(plat) {
    this.setState({ plat });
    if (plat === '') {
      this.addEmptyError('plat');
    } else {
      this.removeError('plat');
    }
  }

  handleChangeName(e) {
    const name = e.target.value;
    this.setState({ name });
    if (name === '') {
      this.addEmptyError('name');
    } else {
      this.removeError('name');
    }
  }

  handleChangeMac(e) {
    let { mac, macCurPos } = this.state;
    macCurPos = e.target.selectionEnd;
    mac = formatMacInput(e.target.value, mac);
    if (e.target.value.length === macCurPos) {
      // stick cursor to end
      macCurPos = mac.length;
    }
    this.setState({
      mac,
      macCurPos,
    });

    const { errors } = this.state;

    if (mac === '') {
      this.addEmptyError('mac');
    } else if (!isValidMac(mac)) {
      this.setState({
        errors: errors.add('FE_MACINVALID', 'mac'),
      });
    } else {
      this.removeError('mac');
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      showErrors: true,
    });

    let { errors } = this.state;
    errors = errors.remove('submit');
    this.setState({
      errors,
      formStatus: 'loading',
    });

    if (!errors.isEmpty()) {
      return;
    }

    const { addGateway } = this.props;
    const {
      mac = '',
      name = '',
      city = '',
      area = '',
      address = '',
      lat = '',
      lng = '',
      plat: platform = '',
    } = this.state;

    addGateway({
      mac: normalizeMac(mac),
      name,
      city,
      area,
      address,
      lat,
      lng,
      platform,
    });
  }

  renderErrorTips(target) {
    const { errors, showErrors = false } = this.state;
    const error = errors.get(target);
    return (
      <ControlTips
        show={showErrors && !isNil(error)}
        message={(
          <span>
            <span className="halflings halflings-warning-sign" />
            &nbsp;{this.intlMsg.errorMsg(error)}
          </span>
        )}
        azStyle="danger"
      />
    );
  }

  render() {
    const {
      platOpts,
      showErrors = false,
      errors,
      name = '',
      mac = '',
      city = '',
      area = '',
      address = '',
      addStatus = '',
    } = this.state;
    const that = this;

    return (
      <div styleName="wrapper" style={{ minHeight: window.innerHeight }}>
        <div styleName="breadcrumbs">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => this.props.pushState('/gateway')}>
              {this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail')}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {this.intlMsg.msg('breadcrumbs.gatewayadd', 'gatewaydetail')}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div styleName="content">
          <div styleName="form-wrapper">
            <Panel bsStyle="aisz-white">
              <Form onSubmit={this.handleSubmit}>
                <FormGroup validationState={errors.has('plat') && showErrors ? 'error' : undefined}>
                  <ControlLabel>
                    {this.intlMsg.msg('field.platform')}
                    {' '}
                    <span className="glyphicon glyphicon-asterisk" />
                  </ControlLabel>
                  <SearchSelector
                    className="aisz-form-control-f"
                    options={platOpts}
                    onChange={this.handleChangePlat}
                  />
                  {this.renderErrorTips('plat')}
                  <HelpBlock styleName="field-explain">
                    <i className="fa fa-info-circle" />
                    {' '}
                    {this.intlMsg.msg('field.platform.explain')}
                  </HelpBlock>
                </FormGroup>
                <FormGroup validationState={errors.has('name') && showErrors ? 'error' : undefined}>
                  <ControlLabel>
                    {this.intlMsg.msg('field.name')}
                    {' '}
                    <span className="glyphicon glyphicon-asterisk" aria-hidden="true" />
                  </ControlLabel>
                  <FormControl
                    bsClass="aisz-form-control-f"
                    value={name}
                    onChange={this.handleChangeName}
                  />
                  {this.renderErrorTips('name')}
                </FormGroup>
                <FormGroup validationState={errors.has('mac') && showErrors ? 'error' : undefined}>
                  <ControlLabel>
                    {this.intlMsg.msg('field.mac')}
                    {' '}
                    <span className="glyphicon glyphicon-asterisk" aria-hidden="true" />
                  </ControlLabel>
                  <FormControl
                    inputRef={(ref) => { this.macInputRef = ref; }}
                    bsClass="aisz-form-control-f"
                    placeholder="12-34-56-78-90-AB"
                    value={mac}
                    onChange={this.handleChangeMac}
                    onBlur={() => this.setState({ macCurPos: null })}
                  />
                  {this.renderErrorTips('mac')}
                  <HelpBlock styleName="field-explain">
                    <i className="fa fa-info-circle" aria-hidden="true" />
                    {' '}
                    {this.intlMsg.msg('field.mac.explain')}
                  </HelpBlock>
                </FormGroup>
                <div styleName="form-divider" />
                <div styleName="optional-fields">
                  <HelpBlock styleName="field-explain">
                    <i className="fa fa-info-circle" aria-hidden="true" />
                    {' '}
                    {this.intlMsg.msg('fieldgroups.location.explain')}
                  </HelpBlock>
                  <FormGroup>
                    <ControlLabel> {this.intlMsg.msg('field.city')} </ControlLabel>
                    <FormControl
                      bsClass="aisz-form-control-f"
                      value={city}
                      onChange={e => this.setState({ city: e.target.value.trim() })}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel> {this.intlMsg.msg('field.area')} </ControlLabel>
                    <FormControl
                      bsClass="aisz-form-control-f"
                      value={area}
                      onChange={e => this.setState({ area: e.target.value.trim() })}
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>
                      {this.intlMsg.msg('field.addr')}
                    </ControlLabel>
                    <FormControl
                      bsClass="aisz-form-control-f"
                      value={address}
                      onChange={e => this.setState({ address: e.target.value.trim() })}
                    />
                  </FormGroup>
                </div>
                <FormGroup>
                  <FormBlock
                    show={errors.has('submit')}
                    message={this.intlMsg.errorMsg(errors.get('submit'))}
                    azStyle="danger"
                  />
                </FormGroup>
                <FormGroup className="text-center">
                  <RichButton
                    status={addStatus}
                    states={[{
                      status: '',
                      style: 'info',
                      label: <span><span className="halflings halflings-ok" /> {this.intlMsg.msg('button.submit')}</span>,
                      type: 'submit',
                    }, {
                      status: 'pending',
                      style: 'info',
                      label: <span><i className="fa fa-spinner fa-spin" /> {this.intlMsg.msg('button.pending')}</span>,
                    }, {
                      status: 'success',
                      style: 'success',
                      label: <span><span className="halflings halflings-ok" /> {this.intlMsg.msg('button.succ')}</span>,
                      timer: () => {
                        if (that.mounted) {
                          this.setState({ addStatus: '' });
                        }
                      },
                    }, {
                      status: 'failure',
                      style: 'danger',
                      label: <span><span className="halflings halflings-exclamation-sign" /> {this.intlMsg.msg('button.fail')}</span>,
                      timer: () => {
                        if (that.mounted) {
                          this.setState({
                            addStatus: '',
                            errors: that.state.errors.remove('submit'),
                          });
                        }
                      },
                    }]}
                  />
                </FormGroup>
              </Form>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

GatewayAdd.propTypes = propTypes;


const mapStateToProps = state => ({
  platOpts: platOptsSelector(state),
  addResult: state.gateway.addGateway,
});

const mapDispatchToProps = ({
  pushState: routerActions.push,
  getPlatforms: enumsActions.platforms,
  addGateway: gatewayActions.addGateway,
  getGatewayUsage: usageActions.gateways,
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(GatewayAdd, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayAdd/index.jsx